import { FC } from 'react';
import { ZoneTag } from 'src/components/ui/ZoneTag';
import { PolygonsFilterType } from 'src/config/types';
import { useAppSelector } from 'src/hooks/useRedux';

interface ManagementFunctionsFilterProps {
  handleSelect: (id: number, filterName: keyof PolygonsFilterType) => void;
  tempFilter: PolygonsFilterType;
}

export const ManagementFunctionsFilter: FC<ManagementFunctionsFilterProps> = ({
  handleSelect,
  tempFilter,
}) => {
  const { management_functions } = useAppSelector(state => state.categories);

  return (
    <div className="flex flex-wrap gap-2">
      {management_functions.map(func => (
        <ZoneTag
          key={`management-func-${func.id}`}
          isActive={tempFilter?.management_functions?.includes(func.id)}
          fullWidth
          onClick={() => handleSelect(func.id, 'management_functions')}
          category={func}
        />
      ))}
    </div>
  );
};
